const SELECTOR = '.filepicker:not(.filepicker-async)';

const lang = $('html').attr('lang');
let localesObj;

if (lang === 'es' || lang === 'es-CL') {
  localesObj = {
    defaultMessage: 'Arrastra uno o varios archivos a esta zona o haz clic para explorar',
    defaultMessageSingle: 'Arrastra un archivo a esta zona o haz clic para explorar',
    fileTooBig: 'El archivo es demasiado grande. Tamaño de archivo máximo: 50 MB',
    invalidFileType: 'No puedes subir archivos de este tipo.',
    filesTooBig: 'No puedes subir más de 50 MB a la vez',
    invalidField: 'Campo no válido',
  };
} else if (lang === 'el') {
  localesObj = {
    defaultMessage: 'Σύρετε και αποθέστε ένα ή περισσότερα αρχεία για μεταφόρτωση ή κάντε κλικ για εξερεύνηση',
    defaultMessageSingle: 'Σύρετε και αποθέστε ένα αρχείο για μεταφόρτωση ή κάντε κλικ για εξερεύνηση',
    fileTooBig: 'Το αρχείο είναι πολύ μεγάλο. Μέγιστο μέγεθος αρχείου: 50 MB',
    invalidFileType: 'Δεν μπορείτε να ανεβάσετε αρχεία αυτού του τύπου',
    filesTooBig: 'Δεν μπορείτε να ανεβάσετε περισσότερα από 50 MB κάθε φορά',
    invalidField: 'Μη έγκυρο πεδίο',
  };
} else if (lang === 'fr') {
  localesObj = {
    defaultMessage: 'Faites glisser et déposez un ou plusieurs fichiers à télécharger ou cliquez pour explorer',
    defaultMessageSingle: 'Faites glisser et déposez un fichier à télécharger ou cliquez pour explorer',
    fileTooBig: 'Le fichier est trop volumineux. Taille maximale du fichier : 50 Mo',
    invalidFileType: 'Vous ne pouvez pas télécharger de fichiers de ce type',
    filesTooBig: 'Vous ne pouvez pas télécharger plus de 50 Mo à la fois',
    invalidField: 'Champ invalide',
  };
} else if (lang === 'hr') {
  localesObj = {
    defaultMessage: 'Povucite i ispustite jednu ili više datoteka za prijenos ili kliknite za istraživanje',
    defaultMessageSingle: 'Povucite i ispustite datoteku za prijenos ili kliknite za istraživanje',
    fileTooBig: 'Datoteka je prevelika. Maksimalna veličina datoteke: 50 MB',
    invalidFileType: 'Ne možete učitati datoteke ove vrste',
    filesTooBig: 'Ne možete učitati više od 50 MB odjednom',
    invalidField: 'Nevažeće polje',
  };
} else if (lang === 'hu') {
  localesObj = {
    defaultMessage: 'Húzzon egy vagy több fájlt a feltöltéshez, vagy kattintson a felfedezéshez',
    defaultMessageSingle: 'Húzza át a fájlt a feltöltéshez, vagy kattintson a felfedezéshez',
    fileTooBig: 'A fájl túl nagy. Maximális fájlméret: 50 MB',
    invalidFileType: 'Nem tölthet fel ilyen típusú fájlokat',
    filesTooBig: 'Egyszerre nem tölthet fel 50 MB-nál többet',
    invalidField: 'Érvénytelen mező',
  };
} else if (lang === 'it') {
  localesObj = {
    defaultMessage: 'Trascina e rilascia uno o più file da caricare o fai clic per esplorare',
    defaultMessageSingle: 'Trascina e rilascia un file da caricare o fai clic per esplorare',
    fileTooBig: 'Il file è troppo grande. Dimensione massima del file: 50 MB',
    invalidFileType: 'Non puoi caricare file di questo tipo',
    filesTooBig: 'Non puoi caricare più di 50 MB alla volta',
    invalidField: 'Campo non valido',
  };
} else if (lang === 'nl') {
  localesObj = {
    defaultMessage: 'Sleep een of meer bestanden om ze te uploaden of klik om ze te verkennen',
    defaultMessageSingle: 'Sleep een bestand en zet het neer om te uploaden of klik om te verkennen',
    fileTooBig: 'Bestand is te groot. Maximale bestandsgrootte: 50 MB',
    invalidFileType: 'U kunt dit type bestanden niet uploaden',
    filesTooBig: 'Je kunt niet meer dan 50 MB per keer uploaden',
    invalidField: 'Ongeldig veld',
  };
} else if (lang === 'pt' || lang === 'pt-BR') {
  localesObj = {
    defaultMessage: 'Arraste e solte um ou mais arquivos para fazer upload ou clique para explorar',
    defaultMessageSingle: 'Arraste e solte um arquivo para fazer upload ou clique para explorar',
    fileTooBig: 'O arquivo é muito grande. Tamanho máximo do arquivo: 50 MB',
    invalidFileType: 'Você não pode fazer upload de arquivos deste tipo',
    filesTooBig: 'Você não pode fazer upload de mais de 50 MB por vez',
    invalidField: 'Campo inválido',
  };
} else if (lang === 'sr-RS') {
  localesObj = {
    defaultMessage: 'Превуците и отпустите једну или више датотека за отпремање или кликните да бисте истражили',
    defaultMessageSingle: 'Превуците и отпустите датотеку да бисте је отпремили или кликните да бисте је истражили',
    fileTooBig: 'Фајл је превелик. Максимална величина датотеке: 50 МБ',
    invalidFileType: 'Не можете да отпремате датотеке овог типа',
    filesTooBig: 'Не можете истовремено да отпремите више од 50 МБ',
    invalidField: 'Неважеће поље',
  };
} else if (lang === 'tr') {
  localesObj = {
    defaultMessage: 'Yüklemek için bir veya daha fazla dosyayı sürükleyip bırakın veya keşfetmek için tıklayın',
    defaultMessageSingle: 'Yüklemek için bir dosyayı sürükleyip bırakın veya keşfetmek için tıklayın',
    fileTooBig: 'Dosya çok büyük. Maksimum dosya boyutu: 50 MB',
    invalidFileType: 'Bu türdeki dosyaları yükleyemezsiniz',
    filesTooBig: "Tek seferde 50 MB'tan fazlasını yükleyemezsiniz",
    invalidField: 'Geçersiz alan',
  };
} else if (lang === 'zh') {
  localesObj = {
    defaultMessage: '拖放一個或多個文件以上傳或單擊以瀏覽',
    defaultMessageSingle: '拖放要上傳的文件或單擊以瀏覽',
    fileTooBig: '文件太大。 最大文件大小: 50 MB',
    invalidFileType: '您無法上傳該類型的文件',
    filesTooBig: '一次上傳的大小不能超過 50 MB',
    invalidField: '無效字段',
  };
} else {
  localesObj = {
    defaultMessage: 'Drag and drop one or more files to upload or click to explore',
    defaultMessageSingle: 'Drag and drop a file to upload or click to explore',
    fileTooBig: 'File is too big. Max filesize: 50 MB',
    invalidFileType: "You can't upload files of this type",
    filesTooBig: 'You can not upload more than 50 MB at time',
    invalidField: 'Invalid field',
  };
}

const locales = {
  i18n: localesObj,
};

async function loadComponent() {
  try {
    const { default: Filepicker } = await import(/* webpackChunkName: 'filepicker' */ '@bizneo/filepicker/filepicker.svelte');

    return Filepicker;
  } catch (error) {
    return Promise.reject(error);
  }
}

function getOptions(options) {
  return Object.keys(options).reduce((newObj, key) => {
    const originalName = key.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
    return { ...newObj, [originalName]: options[key] };
  }, {});
}

export default async function mountFilepicker(_index, el) {
  const $el = $(el);
  const options = getOptions($el.data());
  locales.i18n.defaultMessage = options.multiple ?
    localesObj.defaultMessage
    : localesObj.defaultMessageSingle;

  const Filepicker = await loadComponent();
  const fpInstance = new Filepicker({
    target: el,
    props: {
      maxFilesize: options.maxfilesize || 20,
      maxTotalSize: options.maxtotalsize || 20,
      ...locales,
      ...options,
    },
  });

  return fpInstance;
}

$(document).on('dom-update', (e) => $(e.target).find(SELECTOR).each(mountFilepicker));
